import {useCallback, useEffect, useState} from "react";
import {closeKeepTabOpenNotice, keepTabOpenNoticeOpens} from "./keepTabOpenNotice";

export interface KeepTabOpenNotice {
	open: boolean;
	/** The "Don't show this again" box, unticked until the sender ticks it. */
	dontShowAgain: boolean;
	setDontShowAgain: (checked: boolean) => void;
	/** Every way out of the notice: its button, Escape and the scrim alike. */
	close: () => void;
}

/**
 * The keep-this-tab-open notice's state on one live card (kitecorp/transferify-ui#3724). A thin adapter: when it
 * opens and what closing it records are `./keepTabOpenNotice`'s rules.
 */
export function useKeepTabOpenNotice(live: boolean): KeepTabOpenNotice {
	const [shown, setShown] = useState(false);
	const [open, setOpen] = useState(false);
	const [dontShowAgain, setDontShowAgain] = useState(false);
	// In an effect rather than during render: the rule reads browser storage, which a prerender must not touch.
	useEffect(() => {
		if (keepTabOpenNoticeOpens({live, shown})) {
			setShown(true);
			setOpen(true);
		}
	}, [live, shown]);
	const close = useCallback(() => {
		closeKeepTabOpenNotice(dontShowAgain);
		setOpen(false);
	}, [dontShowAgain]);
	return {open, dontShowAgain, setDontShowAgain, close};
}
